import React from "react";
import { colorOptions } from "../utils";
import "../assets/styles/colors.css";

export const ModalColor = ({ color, setColor }) => {
  return (
    <div className="modal-color">
      <p>Select colour</p>
      {colorOptions.map((c) => (
        <React.Fragment key={c}>
          <input
            type="radio"
            name="color"
            value={c}
            id={c}
            onClick={({ target }) => setColor(target.value)}
            className={`.${c} ${color === c ? "active" : ""} color-option`}
          />
          <label
            htmlFor={c}
            className={`${c} ${color === c ? "active" : ""} color-option-label`}
          />
        </React.Fragment>
      ))}
    </div>
  );
};
